import moment from "moment";
import Breadcrumb from "../../../../component/Breadcrumb";
import { useSelector } from "react-redux";

export const TranslationExportDebug = () => {

    const auth = useSelector((state) => state.auth);

    const currentTime = new Date();

    const confirmationMessage = 'You will receive an e-mail confirmation when the export debug request is complete. Locate and download the export debug report under Reports.'

    return (
        <div className="dashboard-ecommerce">
            <div className="container-fluid dashboard-content">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <Breadcrumb />
                        <div className="widget">
                            <div className="card-header">Export Job Request</div>
                            <hr className="hr" />
                            <div className="px-3 py-2">
                                <div>
                                    This request DOES NOT update the entries to <b>In Translation</b> mode. This request provides report on entries that eligible for Translation. An entry will qualify for translation if it meets below mentioned criteria.
                                </div>
                                <ul>
                                    <li>Last updated by should NOT be <b>Translation Integration.</b></li>
                                    <li>Entry should be in <b>Published Status</b></li>
                                    <li>Entry should be from the below mentioned content type</li>
                                </ul>
                            </div>
                            <div className="container">
                                <div className="row align-items-center my-4">
                                    <div className="text-black col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12">
                                        User Name
                                    </div>
                                    <input
                                        className="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12 px-2 py-1"
                                        value={auth.userInfo?.name}
                                        disabled
                                    />
                                </div>
                                <div className="row align-items-center my-2">
                                    <div className="text-black col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12">
                                        Date & Time
                                    </div>
                                    <input
                                        className="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12 px-2 py-1"
                                        value={moment(currentTime).format("MM/DD/YYYY hh:mm a")}
                                        disabled
                                    />
                                </div>
                                <div className="pb-2 pt-2">
                                    <div className="row">
                                        <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12" />
                                        <button
                                            className="submitButton col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12"
                                            type="button"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                    <div className="row">
                                        <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12" />
                                        <span className="mandatory-small">*Mandatory</span>
                                    </div>
                                </div>
                                <div className="text-teal pb-2">
                                    {confirmationMessage}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
